import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopDashboardsPanel from "@/entities/analytics/dashboards/TopDashboardsPanel.vue";
import DashboardsViewForm from "@/entities/analytics/dashboards/DashboardsViewForm.vue";

import { useAuthStore } from "@/store/auth/login";
import { useOwnWorkbooksStore } from "@/store/catalog_data/dashboards";


export default /*#__PURE__*/_defineComponent({
  __name: 'DasboardsPage',
  setup(__props) {

const authStore = useAuthStore();
const workbooksStore = useOwnWorkbooksStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["analytics:read", "analytics:edit"]
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopDashboardsPanel, { "name-dashbords": "Дашборды" }),
          _createVNode(DashboardsViewForm, {
            store: _unref(workbooksStore),
            type: "own_workbook"
          }, null, 8, ["store"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})